<template>
    <v-row class="mt-4">
        <v-spacer></v-spacer>
        <v-col cols="auto">
            <v-btn color="white" class="green--text px-2" @click="excel">
                <v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon>
                엑셀다운로드
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import XLSX from "xlsx";
import api from "@/api";
import dayjs from "dayjs";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    props: {
        filter: { type: Object },
    },
    data() {
        return {
            mdiMicrosoftExcel,
        };
    },
    computed: {
        payload() {
            return this.$store.state.payload || {};
        },
        scope() {
            return this.payload.scope || [];
        },
        isInterior() {
            return this.scope.includes("interior");
        },
        _user() {
            return this.payload._user;
        },
    },
    methods: {
        async excel() {
            try {
                const { filter, isInterior, _user, getTotalAmount } = this;
                const params = { ...filter };

                if (isInterior) params._interiors = _user; // 인테리어 업체 필터링

                const { contracts } = await api.console.contracts.getContracts({ params });

                const data = contracts.reduce(
                    (array, contract) => [
                        ...array,
                        isInterior
                            ? {
                                  계약번호: contract.contractNumber,
                                  계약진행일: contract.latestDocument.signsAt.toDate(),
                                  공사시작일: contract.latestDocument.startsAt.toDate(),
                                  공사종료일: contract.latestDocument.endsAt.toDate(),
                                  공사지: contract.latestDocument.employer.address,
                                  고객명: contract.latestDocument.employer.name,
                                  고객연락처: contract.latestDocument.employer.phone
                                      .split("-")
                                      .join("")
                                      .phoneNumberFormat(),
                                  총공사금액: getTotalAmount(contract.latestDocument.paymentPlan),
                                  총입금액: getTotalAmount(contract.payments),
                              }
                            : {
                                  계약번호: contract.contractNumber,
                                  계약진행일: contract.latestDocument.signsAt.toDate(),
                                  공사시작일: contract.latestDocument.startsAt.toDate(),
                                  공사종료일: contract.latestDocument.endsAt.toDate(),
                                  공사지: contract.latestDocument.employer.address,
                                  업체명: contract.latestDocument.employee.businessName,
                                  업체사업자등록번호: contract.latestDocument.employee.businessNumber,
                                  업체연락처: contract.latestDocument.employee.phone
                                      .split("-")
                                      .join("")
                                      .phoneNumberFormat(),
                                  고객명: contract.latestDocument.employer.name,
                                  고객연락처: contract.latestDocument.employer.phone
                                      .split("-")
                                      .join("")
                                      .phoneNumberFormat(),
                                  총공사금액: getTotalAmount(contract.latestDocument.paymentPlan),
                                  총입금액: getTotalAmount(contract.payments),
                              },
                    ],
                    []
                );

                const workbook = new XLSX.utils.book_new();
                const worksheet = XLSX.utils.json_to_sheet(data);

                XLSX.utils.book_append_sheet(workbook, worksheet, "new");
                XLSX.writeFile(workbook, `안심계약목록-${dayjs().format("YYYYMMDDTHHmmss")}.xlsx`);
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
                else alert(error.message.toString());
            }
        },

        getTotalAmount(array) {
            return array.reduce((totalAmount, { amount }) => +totalAmount + +amount, 0).format();
        },
    },
};
</script>

<style></style>
